import { Grid, GridProps, SxProps, Theme } from '@mui/material';

const defaultSize: GridProps['size'] = { xs: 12, sm: 12, md: 6 };
const defaultSx: SxProps<Theme> = {
  alignSelf: 'flex-end',
};

export const FormGridItem = ({ size = defaultSize, sx, ...props }: GridProps) => {
  const mergedSx = [defaultSx, ...(Array.isArray(sx) ? sx : [sx])] as SxProps<Theme>;

  return <Grid size={size} sx={mergedSx} {...props} />;
};

export default FormGridItem;
